import React, { useState } from "react"
import ReactDOM from "react-dom"
import { PopMask } from "../../shared/layer"
import { single_quote, quote_item_name } from "../../shared/quotedata/index"

export function PanKouLoadMore(props: { detail_data: any }) {
  const [loadmoreVisible, setLoadmoreVisible] = useState(false)

  const loadmore = () => {
    setLoadmoreVisible(true)
  }

  return (
    <>
      <span className={`pk-load-more ${(single_quote[quote_item_name["市盈率(动)"]](props.detail_data).source).toString().length>4?"pk-special-load-more":""}`} onClick={loadmore}></span>
      {loadmoreVisible && (
        <>
          <PETips detail_data={props.detail_data} onClose={()=>{setLoadmoreVisible(false)}}/>
          <PopMask onClose={() => setLoadmoreVisible(false)} />
        </>
      )}
    </>
  )
}
// 市盈率注释
function PETips(props: { detail_data: any,onClose:Function }) {
  const loadmore = ()=>{
    location.href = `/quote/stockmore_new.html?id=${props.detail_data.f57}&mk=${props.detail_data.f107}`
  }

  return ReactDOM.createPortal(
    <>
      <div className="pe-tips">
        <h5 className="title">市盈率</h5>
        <div className="item">
          <span className="square square-one"></span>
          <span className="trangle trangle-one"></span>&nbsp;
          <span>市盈率(动)</span>
          {single_quote[quote_item_name["市盈率(动)"]](props.detail_data).element}
          <p>总市值/预估全年净利润</p>
        </div>
        <div className="item">
          <span className="square square-two"></span>
          <span className="trangle trangle-two"></span>&nbsp;
          <span>市盈率(静)</span>
          {single_quote[quote_item_name["市盈率(静)"]](props.detail_data).element}
          <p>总市值/上年度净利润</p>
        </div>
        <div className="item">
          <span className="square square-three"></span>
          <span className="trangle trangle-three"></span>&nbsp;
          <span>市盈率(TTM)</span>
          {single_quote[quote_item_name["市盈率(TTM)"]](props.detail_data).element}
          <p>总市值/最近4个季度净利润之和</p>
        </div>
        <br />
        <footer>
          <a
            href="#"
            className="default-popup-cancel popup-button"
            onClick={(e) => {
              e.preventDefault()
              props.onClose()
            }}
          >
            关闭
          </a>
          <a
            href="#"
            className="default-popup-ok button"
            onClick={(e) => {
              e.preventDefault()
              loadmore()
            }}
          >
            更多指标
          </a>
        </footer>
      </div>
    </>,
    document.body
  )
}
